import React from "react";
export var HeaderContext = /*#__PURE__*/React.createContext({});